import { useAuth } from "@/core/auth/hooks";
import { useEffect } from "react";
import i18n from "./i18next";

/**
 * Profile wins over localStorage and the browser: whenever the session user
 * carries a saved locale (login, refresh, org switch, profile update), switch
 * to it. Not in the `@/core/i18n` barrel — it reaches the store, which the
 * API base query (an i18n consumer) sits under.
 */
export const useUserLocaleSync = (): void => {
  const locale = useAuth().user?.locale ?? null;

  useEffect(() => {
    if (locale && locale !== i18n.resolvedLanguage) {
      void i18n.changeLanguage(locale);
    }
  }, [locale]);
};
